export default __webpack_public_path__ + "static/media/hand_tattoo.c31427ed.jpg";